export const EqualityTraitSymbol = Symbol('Equality')

/**
 * @typedef {{ [EqualityTraitSymbol]:(other:EqualityTrait)=>boolean }} EqualityTrait
 */
